import { createAction, handleActions } from "redux-actions";

import { getThemeFromURL } from "../../utils/helpers";
import { tryRestoreCurrentTheme } from "../../utils/userSessionStorage";

// actions
const actionScope = "USER_SESSION_";

export const userSessionRequestFailed = createAction(actionScope + "REQUEST_FAIL");

export const setThemeRequest = createAction(actionScope + "SET_THEME_REQUEST");
export const setThemeSuccess = createAction(actionScope + "SET_THEME_SUCCESS");

export const setAwsUserRequest = createAction(actionScope + "SET_AWS_USER_REQUEST");
export const setAwsUserSuccess = createAction(actionScope + "SET_AWS_USER_SUCCESS");

export const setAwsGroupRequest = createAction(actionScope + "SET_AWS_GROUP_REQUEST");
export const setAwsGroupSuccess = createAction(actionScope + "SET_AWS_GROUP_SUCCESS");

export const setBpShowChatRequest = createAction(actionScope + "SET_BP_SHOW_CHAT_REQUEST");
export const setBpShowChatSuccess = createAction(actionScope + "SET_BP_SHOW_CHAT_SUCCESS");

export const setShowSettingsRequest = createAction(actionScope + "SET_SHOW_SETTINGS_REQUEST");
export const setShowSettingsSuccess = createAction(actionScope + "SET_SHOW_SETTINGS_SUCCESS");

// Pure UI flag (no saga) for the expandable portal navigation drawer.
export const setNavDrawerOpen = createAction(actionScope + "SET_NAV_DRAWER_OPEN");

export const loadUserODMRequest = createAction(actionScope + "LOAD_USER_ODM_REQUEST");
export const loadUserODMSuccess = createAction(actionScope + "LOAD_USER_ODM_SUCCESS");

export const setUserODMRequest = createAction(actionScope + "SET_USER_ODM_REQUEST");
export const setUserODMSuccess = createAction(actionScope + "SET_USER_ODM_SUCCESS");

export const loadUserToDosRequest = createAction(actionScope + "LOAD_USER_TODOS_REQUEST");
export const loadUserToDosSuccess = createAction(actionScope + "LOAD_USER_TODOS_SUCCESS");

export const updateUserToDosRequest = createAction(actionScope + "UPDATE_USER_TODOS_REQUEST");
export const updateUserToDosSuccess = createAction(actionScope + "UPDATE_USER_TODOS_SUCCESS");

export const reflectUpdatedUserODMRequest = createAction(
  actionScope + "REFLECT_UPDATE_USER_REQUEST",
);
export const reflectUpdatedUserODMSuccess = createAction(
  actionScope + "REFLECT_UPDATE_USER_SUCCESS",
);

export const loadOrganizationODMRequest = createAction(
  actionScope + "LOAD_ORGANIZATION_ODM_REQUEST",
);
export const loadOrganizationODMSuccess = createAction(
  actionScope + "LOAD_ORGANIZATION_ODM_SUCCESS",
);

export const setOrganizationODMRequest = createAction(actionScope + "SET_ORGANIZATION_ODM_REQUEST");
export const setOrganizationODMSuccess = createAction(actionScope + "SET_ORGANIZATION_ODM_SUCCESS");

export const reflectUpdatedOrganizationODMRequest = createAction(
  actionScope + "REFLECT_UPDATE_ORGANIZATION_REQUEST",
);
export const reflectUpdatedOrganizationODMSuccess = createAction(
  actionScope + "REFLECT_UPDATE_ORGANIZATION_SUCCESS",
);

export const setProxyPatientODMRequest = createAction(actionScope + "SET_PROXYPATIENT_ODM_REQUEST");
export const setProxyPatientODMSuccess = createAction(actionScope + "SET_PROXYPATIENT_ODM_SUCCESS");

export const setBPClientIdRequest = createAction(actionScope + "SET_BOTPRESS_CLIENT_ID_REQUEST");
export const setBPClientIdSuccess = createAction(actionScope + "SET_BOTPRESS_CLIENT_ID_SUCCESS");

export const loadUserAssessmentsRequest = createAction(
  actionScope + "LOAD_USER_ASSESSMENTS_REQUEST",
);
export const loadUserAssessmentsSuccess = createAction(
  actionScope + "LOAD_USER_ASSESSMENTS_SUCCESS",
);

export const setUserAssessmentsRequest = createAction(actionScope + "SET_USER_ASSESSMENTS_REQUEST");
export const setUserAssessmentsSuccess = createAction(actionScope + "SET_USER_ASSESSMENTS_SUCCESS");

//DMEO
export const setUserKPIsRequest = createAction(actionScope + "SET_USER_KPIS_REQUEST");
export const setUserKPIsSuccess = createAction(actionScope + "SET_USER_KPIS_SUCCESS");

export const updateUserKPIRequest = createAction(actionScope + "UPDATE_USER_KPI_REQUEST");
export const updateUserKPISuccess = createAction(actionScope + "UPDATE_USER_KPI_SUCCESS");

// selectors
export const userODMSelector = state => state.userSession.userODM;
export const userTodosSelector = state => state.userSession.userTodos;
export const userKPIsSelector = state => state.userSession.userKPIs;
export const userAssessmentsSelector = state => state.userSession.userAssessments;
export const proxyPatientODMSelector = state => state.userSession.proxyPatientODM;
export const awsUserSelector = state => state.userSession.awsUser;
export const awsGroupSelector = state => state.userSession.awsGroup;
export const organizationODMSelector = state => state.userSession.organizationODM;

// initial state
const initialState = {
  awsUser: null,
  awsGroupMemberships: [],
  awsGroup: null,

  userODM: null,
  userToDos: null,
  organizationODM: null,
  proxyPatientODM: null,
  userAssessments: null,

  themeId: getThemeFromURL(window.location.pathname) ?? tryRestoreCurrentTheme(),

  bpClientId: "ce635d54-d891-49b4-b2da-9150712cc43d",
  bpShowChat: false,

  showSettings: false,

  navDrawerOpen: false,

  //DEMO
  userKPIs: null,
};

// reducers
export default handleActions(
  {
    [userSessionRequestFailed]: state => state,

    [setThemeRequest]: state => state,
    [setThemeSuccess]: (state, { payload }) => ({
      ...state,
      themeId: payload,
    }),

    [setAwsUserRequest]: state => state,
    [setAwsUserSuccess]: (state, { payload }) => ({
      ...state,
      awsUser: payload,
      awsGroupMemberships:
        payload.signInUserSession.accessToken.payload["cognito:groups"] != null
          ? payload.signInUserSession.accessToken.payload["cognito:groups"]
          : [],
    }),

    [setAwsGroupRequest]: state => state,
    [setAwsGroupSuccess]: (state, { payload }) => ({
      ...state,
      awsGroup: payload,
    }),

    [setBpShowChatRequest]: state => state,
    [setBpShowChatSuccess]: (state, { payload }) => ({
      ...state,
      bpShowChat: payload,
    }),

    [setShowSettingsRequest]: state => state,
    [setShowSettingsSuccess]: (state, { payload }) => ({
      ...state,
      showSettings: payload,
    }),

    [setNavDrawerOpen]: (state, { payload }) => ({
      ...state,
      navDrawerOpen: payload,
    }),

    [loadUserODMRequest]: state => state,
    [loadUserODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setUserODMRequest]: state => state,
    [setUserODMSuccess]: (state, { payload }) => ({
      ...state,
      userODM: payload,
    }),

    [loadUserToDosRequest]: state => state,
    [loadUserToDosSuccess]: (state, { payload }) => ({
      ...state,
      userToDos: payload,
    }),

    [updateUserToDosRequest]: state => state,
    [updateUserToDosSuccess]: (state, { payload }) => ({
      ...state,
      userToDos: payload,
    }),

    [reflectUpdatedUserODMRequest]: state => state,
    [reflectUpdatedUserODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [loadOrganizationODMRequest]: state => state,
    [loadOrganizationODMSuccess]: (state, { payload }) => ({
      ...state,
    }),

    [setOrganizationODMRequest]: state => state,
    [setOrganizationODMSuccess]: (state, { payload }) => ({
      ...state,
      organizationODM: payload,
    }),

    [reflectUpdatedOrganizationODMRequest]: state => state,
    [reflectUpdatedOrganizationODMSuccess]: (state, { payload }) => ({
      ...state,
      organizationODM: payload,
    }),

    [setProxyPatientODMRequest]: state => state,
    [setProxyPatientODMSuccess]: (state, { payload }) => ({
      ...state,
      proxyPatientODM: payload,
    }),

    [setBPClientIdRequest]: state => state,
    [setBPClientIdSuccess]: (state, { payload }) => ({
      ...state,
      bpClientId: payload,
    }),
    [setUserAssessmentsRequest]: state => state,
    [setUserAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      userAssessments: payload,
    }),
    [loadUserAssessmentsRequest]: state => state,
    [loadUserAssessmentsSuccess]: (state, { payload }) => ({
      ...state,
      userAssessments: payload,
    }),

    //Demo
    [setUserKPIsRequest]: state => state,
    [setUserKPIsSuccess]: (state, { payload }) => ({
      ...state,
      userKPIs: payload,
    }),
    //Demo
    [updateUserKPIRequest]: state => state,
    [updateUserKPISuccess]: (state, { payload }) => ({
      ...state,
      userKPIs: payload,
    }),
  },
  initialState,
);
